export const ROUTES = {
  HOME: "/home",
  SIGNATURE_FORM: "/upload-signatures/signatures",
  SIGNATURE_SEARCH: "/upload-signatures/search",
} as const;

export const MODES = {
  CREATE: "create",
  EDIT: "edit",
  CLONE: "clone",
} as const;

export type MODETYPE = typeof MODES[keyof typeof MODES];

export const UI_TEXT = {

  LABEL_LAN_ID_REQUIRED: "LAN Id *",
  BTN_RETRIEVE: "Retrieve",
  BTN_RETRIEVING: "Retrieving...",
  BTN_CREATE_NEW: "Create New",
  BTN_EDIT: "Edit",
  BTN_CLONE: "Clone",
  BTN_BACK: "Back",

  UPLOAD_SIGNATURE_PAGE_TITLE: "Upload Signature Utility",
  LINK_SPECIAL_OVERRIDE: "Special Override",

  LABEL_LAN_ID: "LAN Id",
  LABEL_SUB_COMPANY_CODE: "SubCompany Code",
  LABEL_FIRST_NAME: "First Name",
  LABEL_LAST_NAME: "Last Name",
  LABEL_TITLE: "Title",
  LABEL_SIG_TYPE: "Sig Type",
  LABEL_LAN_ID_IF_INACTIVE: "LAN Id to use if Inactive",
  LABEL_MANAGER_LAN_ID: "Manager LAN Id",
  LABEL_SIGNATURE_FILE: "Signature File",

  BTN_UPLOAD: "Upload Signature",
  BTN_UPDATE: "Update Signature",

  TOOLTIP_DISABLED_IN_EDIT: "Disabled in edit mode",

  FILE_ACCEPT: "image/jpeg, image/png",
} as const;

export const MESSAGES = {
  ENTER_LAN_ID: "Please provide the LAN ID",
  DEFAULT_FETCH_ERROR: "Failed to retrieve records",
  OPERATION_FAILED: "Operation failed",
  UPLOADED_SUCCESS: "Signature uploaded successfully",
  UPDATED_SUCCESS: "Signature updated successfully",
  ONLY_JPG_PNG: "Only JPG and PNG allowed",
  UNABLE_TO_CONNECT: "Unable to connect to server",
} as const;

export const CLASSES = {
  LAYOUT_WRAP: "w-full max-w-[1200px] space-y-6",
  INPUT_ROW: "flex items-end gap-6",
  FIELD_CONTAINER: "flex-1",
  ERROR_TEXT: "text-red-600 text-sm",
  GRID_WRAPPER: "w-full",
  BOTTOM_ROW: "flex flex-wrap items-center justify-between gap-3",

  BTN_WIDE: "min-w-[180px]",
  BTN_WIDE_BOLD: "min-w-[180px] font-bold",
  BTN_PRIMARY: "bg-[#1f3a5f] hover:bg-[#192f4c] text-white",
  BTN_DISABLED: "bg-gray-300 cursor-not-allowed text-white",

  PAGE_WRAP: "w-full px-6 py-6",
  PAGE_HEADER_ROW: "flex justify-between items-center mb-6",
  PAGE_TITLE: "text-2xl font-semibold text-blue-700",
  LINK_OVERRIDE: "text-blue-600 underline text-sm",
  FORM_GRID: "grid grid-cols-1 lg:grid-cols-2 gap-8",
  COL_STACK: "space-y-6",
  REQUIRED_MARK: "text-red-400",
  SPINNER_ICON: "h-4 w-4 animate-spin",
  SPINNER_POS: "absolute right-2 top-8 text-gray-400",
  FILE_BLOCK: "mt-6 max-w-md",
  ACTION_ROW: "mt-6 flex gap-3",

  BTN_PRIMARY_WIDE: "min-w-[180px] gap-2",

  ALERT_SUCCESS: "mt-4 px-4 py-2 rounded text-sm bg-green-100 text-green-700",
  ALERT_ERROR: "mt-4 px-4 py-2 rounded text-sm bg-red-100 text-red-700",
} as const;

export const ALERT_TYPE ={
    SUCCESS: "success",
    ERROR: "error"
}

export const FILE_TYPE = {
    JPEG: "image/jpeg",
    PNG: "image/png"
}